import moment from 'moment';
import store from '@/store';

export default function formatDate(
  stringDate: string,
  format: string = 'DD MMMM YYYY, hh:mm A',
  currentLocale: string = store.state.lang.lang,
): string {
  const parsedMomentDate = moment(stringDate);

  if (!parsedMomentDate.isValid()) {
    return '';
  }

  return parsedMomentDate.local(true).locale(currentLocale).format(format);
}
